
export const PATH_GALERIA_PRODUCTION = 'https://antesala.com.ar/assets/img/galeria/';
export const PATH_EVENTO_PRODUCTION = 'https://antesala.com.ar/assets/img/eventos/';
export const PATH_NOTA_PRODUCTION = 'https://antesala.com.ar/assets/img/notas/';
export const PATH_VIDEO_PRODUCTION = 'https://antesala.com.ar/assets/img/videos/';
export const PATH_SALA_PRODUCTION = 'https://www.antesala.com.ar/assets/img/usuarios/';
export const PATH_DESCRIPTION_PRODUCTION = 'https://www.antesala.com.ar/assets/img/salas/';